module.exports = __webpack_public_path__ + "img/agio.5b26d9c3.jpg";